module.exports = __webpack_public_path__ + "img/yfzx01.68f95ece.jpg";